import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import { loginRequest, type LoginRequestParams, type LoginResponse } from '../requests';

export const useLoginMutation = (
  config?: SWRMutationConfiguration<LoginResponse, Error, string, LoginRequestParams>,
) => {
  const { trigger, data, isMutating, error, reset } = useSWRMutation(
    'login-mutation',
    (_, { arg }: { arg: LoginRequestParams }) => loginRequest(arg),
    config,
  );

  return {
    login: trigger,
    loginData: data,
    isLoggingIn: isMutating,
    resetLogin: reset,
    loginError: error,
  };
};
